import React, { useEffect } from 'react'
import {toast} from "react-toastify";
import Hero from '../components/Hero'
import TextSection from '../components/TextSection'
import { textsection_threecareer, textsection_threelistcareer } from '../data/TextsectionData'
import RegionData from '../data/RegionData'
import WagesData from "../data/WagesData.jsx";
import { useNavigate } from 'react-router-dom';
import OfficeLocation from '../components/OfficeLocation.jsx';


const Careers = () => {
  const navigate = useNavigate();
   
  return (
    <>
    <Hero
      title="Your Career, Our Mission"
      description="We’re committed to helping you achieve your goals while creating meaningful impact."
      buttonText=""
      customClass="careerBanner"
      imageSrc=""
      squareColor="careersquare-bg-color"
      onButtonClick={() => navigate('meet-the-experts')}
    />
    <TextSection  data={textsection_threecareer} withSpan={false}/>
    <TextSection  data={textsection_threelistcareer} withSpan={false}/>
    <OfficeLocation/>      
    </>
  )
}

export default Careers